import React from "react";
import Box from "@mui/material/Box";
import Langs from "../../../../../app/lang/langs";
import { formatDate, getLastUpdatedFromDate } from "../../../../../app/utils/helpers";
import InfoRow from "./InfoRow";

export default function CollabShiftView({
  selectedFormData,
  selectedForm,
  collabShiftType,
  getTimeFromDate,
  getSelectedDayPeriodName,
  getGroupLabel,
  getAssignedCollab,
  getTeamLabelFromId,
}) {
  return (
    <Box sx={{ px: 2.5, pt: 2, pb: 12 }}>
      <InfoRow label="COLLAB" value={selectedFormData && selectedFormData.collab} />
      {selectedFormData.from && (
        <InfoRow
          label="START_DATE"
          value={
            <>
              {formatDate(new Date(selectedFormData.from), "DD MMM YYYY")}
              {" - "}
              {collabShiftType && collabShiftType.value == "s"
                ? <Langs str={getSelectedDayPeriodName(selectedFormData.from)} />
                : `${Math.floor(getTimeFromDate(selectedFormData.from) / 60)}:${
                    getTimeFromDate(selectedFormData.from) % 60 === 0
                      ? "00"
                      : getTimeFromDate(selectedFormData.from) % 60
                  }`}
            </>
          }
        />
      )}
      {selectedFormData.to && (
        <InfoRow
          label="END_DATE"
          value={
            <>
              {formatDate(new Date(selectedFormData.to), "DD MMM YYYY")}
              {" - "}
              {collabShiftType && collabShiftType.value == "s"
                ? <Langs str={getSelectedDayPeriodName(selectedFormData.to)} />
                : `${Math.floor(getTimeFromDate(selectedFormData.to) / 60)}:${
                    getTimeFromDate(selectedFormData.to) % 60 === 0
                      ? "00"
                      : getTimeFromDate(selectedFormData.to) % 60
                  }`}
            </>
          }
        />
      )}
      {collabShiftType && selectedForm === "SHIFT" ? (
        <InfoRow label="TYPE" value={<Langs str={collabShiftType.label} />} />
      ) : (
        <InfoRow label="TYPE" value={selectedFormData.type} />
      )}
      {selectedFormData.id_groupe && (
        <InfoRow label="GROUPE" value={getGroupLabel(selectedFormData.id_groupe)} />
      )}
      {selectedFormData.id_collab && (
        <InfoRow label="ASSIGNED" value={getAssignedCollab()} />
      )}
      {selectedFormData.id_team_delegate && (
        <InfoRow label="CLIENT" value={getTeamLabelFromId(selectedFormData.id_team_delegate)} />
      )}
      {selectedFormData.description && (
        <InfoRow label="DESCRIPTION" value={selectedFormData.description} />
      )}
      {selectedFormData.createdBy && (
        <InfoRow label="CREATED_BY" value={selectedFormData.createdBy} />
      )}
      {selectedFormData.updatedAt && (
        <InfoRow
          label="LAST_UPDATED"
          value={
            <>
              {getLastUpdatedFromDate(selectedFormData.updatedAt)}
              {selectedFormData.updatedBy && (
                <span>
                  {" "}
                  <Langs str="by" /> {selectedFormData.updatedBy}
                </span>
              )}
            </>
          }
        />
      )}
    </Box>
  );
}
